import { DAY_NAMES, getDateStr, statusBadge, getNewsTime } from '../calendarUtils';

function MonthlyView({
  calendarDays, newsMap, currentYear, currentMonth,
  todayStr, selectedDateStr, rulesPanelOpen, isInRange, previewMap,
  openPostDetail, openDatePosts, onSelectDate,
}) {
  return (
    <>
      <div className="grid grid-cols-7 mb-2">
        {DAY_NAMES.map((name, i) => (
          <div key={name} className={`text-center py-2 font-bold text-xs uppercase ${i === 0 ? 'text-red-500' : i === 6 ? 'text-blue-500' : 'text-slate-500'}`}>
            {name}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 border border-slate-200 dark:border-slate-800 rounded-lg overflow-hidden"
           style={{ gap: '1px', backgroundColor: 'rgba(148,163,184,0.15)' }}>
        {calendarDays.map((dayObj, idx) => {
          const dateStr = getDateStr(dayObj, currentYear, currentMonth);
          const dayNews = newsMap[dateStr] || [];
          const isToday = dateStr === todayStr;
          const isSunday = idx % 7 === 0;
          const isSaturday = idx % 7 === 6;
          const maxDisplay = 2;
          const hasMore = dayNews.length > maxDisplay;
          const inRange = rulesPanelOpen && isInRange(dateStr) && dayObj.isCurrentMonth;
          const previewCount = previewMap ? (previewMap[dateStr] || 0) : 0;
          const isSelected = selectedDateStr === dateStr && !isToday;

          return (
            <div key={idx} className={`min-h-[80px] sm:min-h-[180px] p-1 sm:p-2 bg-white dark:bg-slate-900 relative cursor-pointer ${!dayObj.isCurrentMonth ? 'opacity-40' : ''} ${isToday ? 'ring-2 ring-primary ring-inset z-10' : ''} ${isSelected ? 'ring-2 ring-violet-400 ring-inset z-10 bg-violet-50 dark:bg-violet-900/20' : ''} ${inRange ? 'bg-primary/5 dark:bg-primary/10' : ''}`}
              onClick={() => { if (dayObj.isCurrentMonth) { onSelectDate?.(dateStr); if (window.innerWidth < 640) { openDatePosts(dateStr, newsMap[dateStr] || []); } } }}>
              <div className="flex items-center justify-between mb-0.5 sm:mb-1">
                <span className={`text-xs sm:text-sm font-bold ${isToday ? 'text-primary' : isSelected ? 'text-violet-500' : isSunday ? 'text-red-500' : isSaturday ? 'text-blue-500' : 'dark:text-slate-300'}`}>
                  {dayObj.day}
                </span>
                {previewCount > 0 && dayObj.isCurrentMonth && (
                  <span className="bg-primary/20 text-primary text-[10px] font-bold px-1.5 py-0.5 rounded-full">+{previewCount}</span>
                )}
              </div>

              {/* 모바일: 이미지 썸네일 도트 */}
              {dayNews.length > 0 && (
                <div className="sm:hidden mt-0.5">
                  <div className="flex flex-wrap justify-center gap-0.5">
                    {dayNews.slice(0, 3).map(news => (
                      <div key={news.id} className="size-5 rounded-full overflow-hidden bg-slate-200 dark:bg-slate-700 ring-1 ring-white dark:ring-slate-900">
                        {news.imageUrl ? (
                          <img src={news.imageUrl} alt="" className="w-full h-full object-cover" onError={(e) => { e.target.parentElement.innerHTML = '<div class="w-full h-full bg-primary/20"></div>'; }} />
                        ) : (
                          <div className="w-full h-full bg-primary/20 flex items-center justify-center">
                            <span className="text-[6px] text-primary font-bold">P</span>
                          </div>
                        )}
                      </div>
                    ))}
                    {dayNews.length > 3 && (
                      <div className="size-5 rounded-full bg-slate-100 dark:bg-slate-800 ring-1 ring-white dark:ring-slate-900 flex items-center justify-center">
                        <span className="text-[8px] font-bold text-slate-500">+{dayNews.length - 3}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {previewCount > 0 && dayObj.isCurrentMonth && (
                <div className="sm:hidden mt-0.5 text-center">
                  <span className="text-[8px] text-primary font-bold">+{previewCount}</span>
                </div>
              )}

              {/* 데스크탑: 카드 UI */}
              <div className="hidden sm:block space-y-1 overflow-hidden">
                {dayNews.slice(0, maxDisplay).map(news => {
                  const badge = statusBadge(news.uploadStatus);
                  const time = getNewsTime(news);
                  return (
                    <div key={news.id} onClick={(e) => { e.stopPropagation(); openPostDetail(news); }}
                      className={`bg-slate-100 dark:bg-slate-800/80 rounded p-1 border ${badge.border} shadow-sm cursor-pointer hover:ring-1 hover:ring-primary/50 transition-all`}>
                      {news.imageUrl && (
                        <div className="relative h-12 w-full mb-0.5 rounded overflow-hidden">
                          <img src={news.imageUrl} alt="" className="w-full h-full object-cover" onError={(e) => { e.target.style.display = 'none'; }} />
                          {time && <div className="absolute top-0.5 right-0.5 bg-black/60 px-1 py-0.5 rounded text-[9px] text-white">{time}</div>}
                          {news.media?.length > 1 && (
                            <span className="absolute bottom-0.5 right-0.5 px-1 py-0.5 bg-black/60 text-white text-[8px] font-bold rounded flex items-center gap-0.5">
                              <span className="material-symbols-outlined" style={{ fontSize: '9px' }}>photo_library</span>
                              {news.media.length}
                            </span>
                          )}
                        </div>
                      )}
                      <p className="text-[10px] leading-tight dark:text-slate-300 line-clamp-2">{news.title || news.description || ''}</p>
                      <div className="flex items-center justify-between mt-1">
                        <span className={`px-1 py-0.5 rounded text-[8px] font-bold ${badge.bg} ${badge.text}`}>{badge.label}</span>
                        {!news.imageUrl && time && (
                          <span className="text-[9px] text-slate-400 flex items-center gap-0.5">
                            <span className="material-symbols-outlined text-[10px]">schedule</span>{time}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}

                {hasMore && (
                  <div onClick={(e) => { e.stopPropagation(); openDatePosts(dateStr, dayNews); }}
                    className="text-center text-[9px] text-primary font-bold cursor-pointer hover:underline">
                    +{dayNews.length - maxDisplay} more
                  </div>
                )}

                {previewCount > 0 && dayObj.isCurrentMonth && (
                  <div className="mt-1 text-center py-2 border-2 border-dashed border-primary/30 rounded bg-primary/5">
                    <span className="text-[10px] text-primary font-bold">{previewCount}개 생성 예정</span>
                  </div>
                )}
              </div>

              {dayObj.isCurrentMonth && dayNews.length === 0 && !previewCount && dateStr >= todayStr && (
                <div onClick={(e) => { e.stopPropagation(); openDatePosts(dateStr, []); }}
                  className="hidden sm:block mt-2 text-center text-[10px] text-slate-400 hover:text-primary py-3 border-2 border-dashed border-slate-200 dark:border-slate-700 hover:border-primary/50 rounded cursor-pointer transition-colors">
                  <span className="material-symbols-outlined text-sm">add_circle_outline</span><br/>등록하기
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default MonthlyView;
